// extracted by mini-css-extract-plugin
export default {"container":"Error_container__BG3Y9","section":"Error_section__PwxcR","sectionInner":"Error_sectionInner__oCF80","error":"Error_error__eeh21"};